<template>
  <div class=body>
    <div v-if="isFirst">
      <img src="@/assets/tutorial/sery/00_intro.png" />
    </div>
    <div v-if="!isCreate"
         class="main">
      <img src="@/assets/tutorial/sery.svg"
           alt="">
      <span>
        세리에 오신것을<br>환영합니다.
      </span>
      <div>
        <img src="@/assets/tutorial/sery/direct-btn-box.png"
             @click.stop="createSmartSms"
             alt="">
        <img src="@/assets/tutorial/sery/price-btn-box.png"
             @click.stop="moveSeryHome"
             alt="">
      </div>
    </div>
    <div v-if="isCreate"
         class="create">
      <div v-if="step === 1"
           class="step1">
        <img src="@/assets/tutorial/sery/step-011.png"
             @click.stop="moveStep(2)" />
      </div>
      <div v-if="step === 2"
           class="step2">
        <img src="@/assets/tutorial/sery/step-02.png"
             @click.stop="moveStep(3)" />
      </div>
      <div v-if="step === 3"
           class="step3">
        <img src="@/assets/tutorial/sery/step-03.png"
             @click.stop="moveStep(4)" />
      </div>
      <div v-if="step === 4"
           class="step4">
        <img v-if="!isStep4"
             src="@/assets/tutorial/sery/step-041.png" />
        <img v-else
             src="@/assets/tutorial/sery/step-042.png" />
      </div>
      <div v-if="step === 5"
           class="step5">
        <img src="@/assets/tutorial/sery/step-05.png"
             @click.stop="moveStep(6)" />
      </div>
      <div v-if="step === 6"
           class="step6">
        <img src="@/assets/tutorial/sery/step-06.png"
             @click.stop="moveStep(7)" />
      </div>
      <div v-if="step === 7"
           class="step7">
        <img v-if="isStep7 === 0"
             src="@/assets/tutorial/sery/step-071.png" />
        <img v-else-if="isStep7 === 1"
             src="@/assets/tutorial/sery/step-072.png" />
        <img v-else
             src="@/assets/tutorial/sery/step-073.png" />
      </div>
      <div v-if="step === 8"
           class="step8">
        <img src="@/assets/tutorial/sery/step-08.png" />
      </div>
      <div v-if="step === 9"
           class="step9">
        <img src="@/assets/tutorial/sery/step-09.png"
             @click.stop="moveStep(10)" />
      </div>
      <div v-if="step === 10"
           class="step10">
        <img v-if="isStep10 === 0"
             :src="require(`@/assets/tutorial/sery/step-10${step10Url}1.png`)" />
        <img v-else-if="isStep10 === 1"
             :src="require(`@/assets/tutorial/sery/step-10${step10Url}2.png`)" />
        <img v-else
             :src="require(`@/assets/tutorial/sery/step-10${step10Url}3.png`)" />
      </div>
      <div v-if="step === 11"
           class="step11">
        <img v-if="!isStep11"
             src="@/assets/tutorial/sery/step-111.png"
             @click.stop="moveStep(12)" />
        <img v-else
             src="@/assets/tutorial/sery/step-112.png"
             @click.stop="moveStep(12)" />
      </div>
      <div v-if="step === 12"
           class="step12">
        <div v-if="isStep12">
          <img src="@/assets/tutorial/sery/btn-message.png"
               @click.stop="sendMessageModal"
               alt="">
          <img src="@/assets/tutorial/sery/btn-call.png"
               @click.stop="requestCallModal"
               alt="">
        </div>
        <embed src="https://home.tery.kr/storeMain?seq=051_00000868&eventSeq=009BJb">
      </div>
    </div>
    <modal name="sendMessage"
           :width="320"
           :height="450">
      <div class="sendMessageBody">
        <img src="@/assets/tutorial/sery.svg" />
        <div>
          <span>스마트전단 받기</span>
          <span>문자받을 전화번호를 입력해주세요.</span>
        </div>
        <div>
          <span>전화번호</span>
          <input v-model="phoneNumber"
                 type="number"
                 placeholder="전화번호를 입력하세요.(숫자만)" />
        </div>
        <img v-if="!isLoading"
             src="@/assets/tutorial/sery/btn-request.png"
             @click.stop="sendMessage" />
      </div>
    </modal>
    <modal name="requestCall"
           :width="320"
           :height="530">
      <div class="requestCallBody">
        <img src="@/assets/tutorial/sery.svg" />
        <div>
          <span>상담신청</span>
          <span>연락드릴 전화번호를 입력해주세요.</span>
        </div>
        <div>
          <span>전화번호</span>
          <input v-model="phoneNumber"
                 type="number"
                 placeholder="전화번호를 입력하세요.(숫자만)" />
        </div>
        <div>
          <span>상담시간</span>
          <input v-model="requestTime"
                 type="text"
                 placeholder="상담가능 시간을 알려주세요.(선택)" />
        </div>
        <img v-if="!isLoading"
             src="@/assets/tutorial/sery/btn-request2.png"
             @click.stop="requestCall" />
      </div>
    </modal>
  </div>
</template>

<script>
export default {
  name: 'sery',
  data () {
    return {
      isFirst: true,
      isCreate: false,
      step: 1,
      isStep4: false,
      isStep7: 0,
      isStep10: 0,
      step10Url: '1',
      isStep11: false,
      isStep12: false,
      phoneNumber: '',
      requestTime: '',
      isLoading: false
    }
  },
  mounted () {
    const vm = this
    vm.$gtag.event('세리에서_발송_되었습니다_인트로', {
      event_category: vm.$route.query.seq,
      event_label: `인트로`,
      value: vm.$cookies.get('userSeq')
    })
    setTimeout(() => {
      vm.isFirst = false
    }, 1500)
  },
  methods: {
    createSmartSms () {
      const vm = this
      vm.$gtag.event('세리에서_발송_되었습니다_직접만들기', {
        event_category: vm.$route.query.seq,
        event_label: `직접_만들기`,
        value: vm.$cookies.get('userSeq')
      })
      vm.isCreate = true
    },
    moveStep (step) {
      const vm = this
      vm.$gtag.event(`세리에서_발송_되었습니다_스마트전단만들기단계-${step}`, {
        event_category: vm.$route.query.seq,
        event_label: `스마트전단_만들기_단계_${step}`,
        value: vm.$cookies.get('userSeq')
      })
      if (step === 2) {
        setTimeout(() => {
          vm.step = step
        }, 2000)
      } else if (step === 3) {
        setTimeout(() => {
          vm.step = step
        }, 2000)
      } else if (step === 4) {
        vm.step = step
        setTimeout(() => {
          if (vm.isStep4) {
            vm.isStep4 = false
          } else {
            vm.isStep4 = true
          }
          setTimeout(() => {
            vm.moveStep(5)
          }, 3000)
        }, 2000)
      } else if (step === 5) {
        setTimeout(() => {
          vm.step = step
        }, 2000)
      } else if (step === 6) {
        setTimeout(() => {
          vm.step = step
        }, 2000)
      } else if (step === 7) {
        vm.step = step
        setTimeout(() => {
          vm.isStep7 = 1
          setTimeout(() => {
            vm.isStep7 = 2
            setTimeout(() => {
              vm.moveStep(8)
            }, 2000)
          }, 1000)
        }, 1000)
      } else if (step === 8) {
        setTimeout(() => {
          vm.moveStep(9)
        }, 6000)
      } else if (step === 9) {
        setTimeout(() => {
          vm.step = step
        }, 2000)
      } else if (step === 10) {
        vm.step = step
        const data = Math.floor(Math.random() * 3) + 1
        vm.step10Url = data
        vm.isStep10 = 0
        setTimeout(() => {
          vm.isStep10 = 1
          setTimeout(() => {
            vm.isStep10 = 2
            setTimeout(() => {
              vm.moveStep(11)
            }, 1000)
          }, 1000)
        }, 1000)
      } else if (step === 11) {
        vm.step = step
        setTimeout(() => {
          if (vm.isStep11) {
            vm.isStep11 = false
          } else {
            vm.isStep11 = true
          }
        }, 2000)
      } else if (step === 12) {
        vm.step = step
        setTimeout(() => {
          vm.isStep12 = true
        }, 7000)
      }
    },
    moveSeryHome () {
      const vm = this
      vm.$gtag.event('세리에서_발송_되었습니다_세리이용료알아보기', {
        event_category: vm.$route.query.seq,
        event_label: '세리_이용료_알아보기',
        value: vm.$cookies.get('userSeq')
      })
      window.open('https://home.sery.co.kr')
    },
    sendMessageModal () {
      const vm = this
      vm.$gtag.event('세리에서_발송_되었습니다_문자로받아보기선택', {
        event_category: vm.$route.query.seq,
        event_label: '문자로_받아보기_선택',
        value: vm.$cookies.get('userSeq')
      })
      vm.$modal.show('sendMessage')
    },
    sendMessage () {
      const vm = this
      if (vm.phoneNumber.replace(/[^0-9]/g, '').length !== 11) {
        alert('올바른 전화번호를 입력해주세요.')
        return
      }
      vm.$gtag.event('세리에서_발송_되었습니다_문자로받아보기발송', {
        event_category: vm.$route.query.seq,
        event_label: '문자로_받아보기_발송',
        value: vm.phoneNumber
      })
      vm.isLoading = true
      const data = {
        user_id: 'tono5003',
        schedule_type: 0,
        subject: '세리입니다.',
        callback_url: '',
        now_date: vm.$dayjs().format('YYYYMMDDHHmmss'),
        send_date: vm.$dayjs().format('YYYYMMDDHHmmss'),
        callback: '16619068',
        dest_count: 1,
        dest_info: `0^${vm.phoneNumber.replace(/[^0-9]/g, '')}`,
        msg_type: 0,
        sms_msg: '(광고)세리에서 만든 전단지가 도착했어요\r\n \r\n확인하기\r\n\r\ntery.kr/009Cgz\n\n무료거부0801564351',
        content_count: 0,
        content_data: '',
        reserved1: '051_00000008',
        reserved2: ''
      }
      vm.$axios({
        method: 'post',
        url: `https://send.sery.co.kr/insertRcsSmsTable`,
        headers: {
          authorization: 'sery.co.kr',
          'Content-Type': 'application/json'
        },
        data: data
      })
        .then((response) => {
          if (response.data === '1' || response.data === 1) {
            vm.$modal.hide('sendMessage')
          }
        })
        .finally(() => {
          vm.phoneNumber = ''
          vm.isLoading = false
        })
    },
    requestCallModal () {
      const vm = this
      vm.$gtag.event('세리에서_발송_되었습니다_상담신청선택', {
        event_category: vm.$route.query.seq,
        event_label: '상담신청_선택',
        value: vm.$cookies.get('userSeq')
      })
      vm.$modal.show('requestCall')
    },
    requestCall () {
      const vm = this
      if (vm.phoneNumber.replace(/[^0-9]/g, '').length !== 11) {
        alert('올바른 전화번호를 입력해주세요.')
        return
      }
      vm.$gtag.event('세리에서_발송_되었습니다_상담신청완료', {
        event_category: vm.$route.query.seq,
        event_label: '상담신청_완료',
        value: vm.phoneNumber
      })
      vm.isLoading = true
      const data = {
        phoneNumber: vm.phoneNumber.replace(/[^0-9]/g, ''),
        requestTime: vm.requestTime
      }
      vm.$axios({
        method: 'post',
        url: `${process.env.telegram}/advise-chat`,
        // url: `http://192.168.0.2:3014/advise-chat`,
        data: data
      })
        .then((response) => {
          if (response.data === 'success') {
            vm.$modal.hide('requestCall')
          }
        })
        .finally(() => {
          vm.phoneNumber = ''
          vm.requestTime = ''
          vm.isLoading = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
img {
  -webkit-tap-highlight-color: transparent!important;
  width: 100%;
  object-fit: contain;
}
.body {
  width: 100%;
  height: 100%;
  background-color: #ebf2f6;
}
.main {
  display: flex;
  flex-direction: column;
  width: 100vw;
  height: 100vh;
  > img {
    width: 1.86781rem;
    height: 3.12038rem;
    flex-shrink: 0;
    margin-top: 7.5rem;
    margin-left: 2.5rem;
  }
  span {
    height: 5.75rem;
    margin-top: 2.75rem;
    margin-left: 2.5rem;
    text-align: left;
    color: var(--grey-scale-black-darkest, #2d1d1d);
    font-family: Pretendard;
    font-size: 2.375rem;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }
  div {
    width: auto;
    height: 12.5rem;
    margin-top: 4rem;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    padding: 1.25rem;
    > img {
      width: 100%;
      object-fit: contain;
      cursor: pointer;
    }
  }
}
.create {
  width: 100%;
  cursor: pointer;
}
.step12 {
  width: 100%;
  height: 100vh;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  > div {
    display: flex;
    width: 12.5rem;
    height: 20rem;
    padding: 1.25rem 2.5rem;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    flex-shrink: 0;
    z-index: 100;
  }
  > embed {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }
}
.sendMessageBody {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 0.25rem;
  background: var(--grey-scale-white, #fff);
  box-shadow: 2px 2px 12px 2px rgba(0, 0, 0, 0.25);
  > img:nth-of-type(1) {
    width: 5rem;
    height: 6.25rem;
    margin-top: 3.13rem;
  }
  > div:nth-of-type(1) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 0.625rem;
    margin-top: 1.25rem;
    margin-left: 1.87rem;
    margin-right: 1.87rem;
    span:first-child {
      color: var(--grey-scale-black-darkest, #2d1d1d);
      text-align: center;
      font-family: Pretendard;
      font-size: 1.5rem;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
    }
    span:last-child {
      color: var(--grey-scale-black-darkest, #2d1d1d);
      text-align: center;
      font-family: Pretendard;
      font-size: 1rem;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
    }
  }
  div:nth-of-type(2) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    width: 16.25rem;
    height: 3.8125rem;
    flex-shrink: 0;
    margin-top: 1.25rem;
    margin-left: 1.87rem;
    margin-right: 1.87rem;
    > span {
      color: var(--grey-scale-black-darkest, #2d1d1d);
      font-family: Pretendard;
      font-size: 0.875rem;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }
    > input {
      width: 100%;
      height: 2.5rem;
      flex-shrink: 0;
      border-radius: 0.25rem;
      border: 1px solid var(--grey-scale-black-light, #b4b4b4);
      background: var(--grey-scale-white, #fff);
    }
  }
  > img:nth-of-type(2) {
    margin-top: 1.25rem;
    margin-bottom: 3.13rem;
    margin-left: 1.87rem;
    margin-right: 1.87rem;
    height: 3.125rem;
    flex-shrink: 0;
    cursor: pointer;
  }
}
.requestCallBody {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 0.25rem;
  background: var(--grey-scale-white, #fff);
  box-shadow: 2px 2px 12px 2px rgba(0, 0, 0, 0.25);
  > img:nth-of-type(1) {
    width: 5rem;
    height: 6.25rem;
    margin-top: 3.13rem;
  }
  > div:nth-of-type(1) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 0.625rem;
    margin-top: 1.25rem;
    margin-left: 1.87rem;
    margin-right: 1.87rem;
    span:first-child {
      color: var(--grey-scale-black-darkest, #2d1d1d);
      text-align: center;
      font-family: Pretendard;
      font-size: 1.5rem;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
    }
    span:last-child {
      color: var(--grey-scale-black-darkest, #2d1d1d);
      text-align: center;
      font-family: Pretendard;
      font-size: 1rem;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
    }
  }
  div:nth-of-type(2) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    width: 16.25rem;
    height: 3.8125rem;
    flex-shrink: 0;
    margin-top: 1.25rem;
    margin-left: 1.87rem;
    margin-right: 1.87rem;
    > span {
      color: var(--grey-scale-black-darkest, #2d1d1d);
      font-family: Pretendard;
      font-size: 0.875rem;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }
    > input {
      width: 100%;
      height: 2.5rem;
      flex-shrink: 0;
      border-radius: 0.25rem;
      border: 1px solid var(--grey-scale-black-light, #b4b4b4);
      background: var(--grey-scale-white, #fff);
    }
  }
  div:nth-of-type(3) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    width: 16.25rem;
    height: 3.8125rem;
    flex-shrink: 0;
    margin-top: 1.25rem;
    margin-left: 1.87rem;
    margin-right: 1.87rem;
    > span {
      color: var(--grey-scale-black-darkest, #2d1d1d);
      font-family: Pretendard;
      font-size: 0.875rem;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }
    > input {
      width: 100%;
      height: 2.5rem;
      flex-shrink: 0;
      border-radius: 0.25rem;
      border: 1px solid var(--grey-scale-black-light, #b4b4b4);
      background: var(--grey-scale-white, #fff);
    }
  }
  > img:nth-of-type(2) {
    margin-top: 1.25rem;
    margin-bottom: 3.13rem;
    margin-left: 1.87rem;
    margin-right: 1.87rem;
    height: 3.125rem;
    flex-shrink: 0;
    cursor: pointer;
  }
}

.circle,
.circle::before {
  content: ' ';
  width: 15px;
  height: 15px;
  border-radius: 50%;
  transition: all 0.3s;
  background-color: rgba(0, 0, 255, 0);
}

.circle::before {
  animation: mymove 1s infinite;
  position: absolute;
  background-color: #ff0000;
  margin-left: -8px;
}

@-webkit-keyframes mymove {
  50% {
    transform: scale(2);
    opacity: 0;
  }
  100% {
    transform: scale(2);
    opacity: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/tutorial/sery.vue